export const imageUrl = import.meta.env.VITE_IMAGE_URL;
export const imageLiveUrl = import.meta.env.VITE_IMAGE_LIVE_URL;
export const env = import.meta.env.VITE_env;
export const url = imageLiveUrl;
export const api_url = import.meta.env.PROD
  ? import.meta.env.VITE_API_LIVE_URL
  : import.meta.env.VITE_API_URL;
// export const api_url = import.meta.env.VITE_API_LIVE_URL;

export const jwtSecret = import.meta.env.VITE_jwtSecret;
